<template>
  <div class="course">
    <div class="head">
      <!-- <span><</span> -->
      <span>安装说明</span>
    </div>
    <div class="main">
      <span class="main_head">详细安装教程</span>
      <span class="main_one">1、安装完成后，点击「APP名称」，会出现下图所示的提示。（注：企业版App需要用户手动信任）</span>
      <div class="img_div">
        <span class="main_span">'iPhoneDistribution:XXXXXXX'在此iPhone上尚未受信任。在信任该开发者之前，某企业级应用将不可使用。</span>
        <img class="main_img" src="../../static/img/azsm_tcbg.png" style="width='2rem'" alt>
      </div>
      <span class="main_two">2、在手机找到「设置」—「通用」—「设备管理」—「xxxxxxxxxxxx」—点击「信任」—返回桌面点击「App名称」就可以开始使用了。</span>
      <span class="main_food">温馨提示：点击 [去信任] 可直接跳转到设备管理，请安装成功后再去信任</span>
    </div>
    <div class="btn">
      <a class="food_btn_a" href="../../static/embedded.mobileprovision">去信任</a>
    </div>
  </div>
</template>

<script>
export default {
  name: "index",
  data() {
    return {
      show: true
    };
  },
  watch: {},
  async created() {},
  methods: {}
};
</script>

<style lang="css" scoped>
.main {
  padding: 0 1rem;
}
.main_head {
  font-size: 22px;
  color: #32b2a7;
  margin: 1rem 0;
  display: inline-block;
}
.main_one,
.main_two {
  display: block;
  color: #222222;
  font-size: 14px;
}
.main_food {
  display: block;
  color: #e44c3f;
  font-size: 12px;
  margin: 1rem 0;
}
.head {
  background: #f4f4f4;
  text-align: center;
  height: 2.5rem;
  line-height: 2.5rem;
  color: #222222;
}
.img_div {
  position: relative;
  padding: 0 0.5rem;
  /* display: flex;
  justify-content: center;
  align-items: center; */
}
.main_span {
  position: absolute;
  width: 11rem;
  font-size: 12px;
  left: 50%;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
}
.main_img {
  width: 100%;
  height: 100%;
}
.btn {
  margin: 0 1rem;
}
.food_btn_a {
  display: inline-block;
  width: 100%;
  height: 3rem;
  background-color: rgb(50, 178, 167);
  border: none;
  border-radius: 5rem;
  font-size: 1rem;
  margin-top: 1rem;
  color: white;
  text-decoration: none;
  line-height: 3rem;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/course.vue